import moment from 'moment-timezone'

// console.log('moment.defaultZone',moment.defaultZone)
moment.tz.setDefault('Asia/Hong_Kong')
// moment.tz.setDefault('America/New_York')
// console.log('moment.defaultZone',moment.defaultZone)
export default moment
